import { render, staticRenderFns } from "./sacrificer_info.vue?vue&type=template&id=efe65dc0&"
import script from "./sacrificer_info.vue?vue&type=script&lang=js&"
export * from "./sacrificer_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports